/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    ContentTextarea,
    DialogCancel,
    DialogConfirm,
    TextArea
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function DialogComponent({ idOperation, show, setDialog, history }) {
    const [visible, setVisible] = useState(show);
    const [cancellationReason, setCancellationReason] = useState("");

    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();

    const handleClickOutside = e => {
        if (!myRef.current.contains(e.target)) {
            setDialog({ visible: false })
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    });

    useEffect(() => {
        setVisible(show);
    }, [show]);

    const handleCancellation = () => {
        fitinsurApi.setAuthToken(authContext.token);
        fitinsurApi.requestCancelEndorsement(idOperation, cancellationReason)
            .then(resp => resp.json())
            .then(data => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }
                history.push(`/polices`);
            })
            .catch((error) => {
                mc.error("Failed to cancel the endorsement\n" + error);
                console.error('fitPostReject - Error:', error);
            });
    }

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon pink={'exclamation'}>
                    {/* <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon> */}
                    <DialogText>REJECT ENDORSEMENT</DialogText>
                </DialogIcon>
                <ContentTextarea>
                    <p>Deal Analysis information</p>
                    <TextArea onChange={(e) => setCancellationReason(e.target.value)} />
                    <DialogCancel 
                        onClick={() => setDialog({ visible: false })}
                        type="button"
                    >
                        Cancel
                   </DialogCancel>
                    <DialogConfirm onClick={() => handleCancellation()}>Confirm</DialogConfirm>
                </ContentTextarea>
            </DialogBody>
        </Dialog>

    );
}